import cx from 'classnames';
import range from 'lodash-es/range';
import { CommentPlaceholder } from 'mk2/apps/blogs/components/CommentPlaceholder';
import { CommentsDesign } from 'mk2/apps/blogs/constants';
import React from 'react';
import styles from './CommentListPlaceholder.mscss';

interface OwnProps {
    commentsCount: number;
    design: CommentsDesign;
}

export const CommentListPlaceholder = React.memo<OwnProps>(({
    design, commentsCount,
}) => (
    <div
        className={cx(
            styles.CommentListPlaceholder,
            styles[`CommentListPlaceholder--${CommentsDesign[design]}`],
        )}
    >
        {range(commentsCount).map((index) => (
            <CommentPlaceholder
                key={index}
                design={design}
            />
        ))}
    </div>
));
